import { getDate } from "./date-time-converter";

function getGtmProductObject(product, withSelectedCourse) {
  const gtmProduct = {
    id: product.gtmId,
    name: product.gtmName,
    category: product.gtmCategory,
    price: product.prices.originalPrice,
    memberPrice: product.prices.membersPrice,
    quantity: product.quantity,
  };

  if (!withSelectedCourse) {
    return gtmProduct;
  }

  const { selectedCourseId, availableStartDates } = product;
  if (selectedCourseId) {
    const selectedCourse = availableStartDates.find(
      (start) => start.courseId === selectedCourseId
    );

    Object.assign(gtmProduct, {
      eventDate: getDate(selectedCourse.startDateList[0].startTime),
      eventLocation: selectedCourse.city,
      gatheringAmount: selectedCourse.startDateList.length,
      courseId: selectedCourseId,
    });
  } else {
    Object.assign(gtmProduct, {
      eventDate: "",
      eventLocation: "",
      gatheringAmount: 0,
      courseId: "",
    });
  }

  return gtmProduct;
}

function getGtmTotalsObject(cart) {
  const gtmCart = {
    subtotal: cart.gtmSubtotal,
    revenue: cart.gtmRevenue,
    memberDiscountApplied: cart.isMember,
  };

  return gtmCart;
}

export { getGtmProductObject, getGtmTotalsObject };
